import { computed } from 'mobx';

export default class DataSourceModel {
  id;
  store;

  dataOriginStore;

  constructor(store, dataSource) {
    this.store = store;
    this.updateFromJson(dataSource);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
      provider: this.provider,
      origins: this.origins,
      daq_processor: this.daq_processor.asJson || {
        protocol: '',
        parser: '',
        aes_key: '',
        location_id: '',
        address: '',
        port_no: '',
        location: {
          source_location: '',
          destination_location: '',
          user_name: '',
          user_password: '',
          interval: '',
          mqtt_topic: '',
          certificate: '',
        }
      },
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.description = json.description;
    this.provider = json.provider;

    this.origins = (json && json.origins && json.origins.map(origin => this.store.dataOriginStore.resolveItem(origin))) || [];
    this.daq_processor = !!json.daq_processor ? this.store.daqProcessorStore.resolveItem(json.daq_processor) : {};
    this.daq_processor_id = !!json.daq_processor_id ? json.daq_processor_id : !!json.daq_processor ? json.daq_processor.id : null;
  }
}



// WEBPACK FOOTER //
// ./src/models/DataSourceModel.js